export const STATES = {
    OPEN: 'OPEN',
    SHOWN: 'SHOWN',
    HIDDEN: 'HIDDEN',
    EMPTY: 'EMPTY',
};
export const EVENTS = {
    INIT_CHAT: 'supportchat:init',
    INITIALIZED: 'supportchat:initialized',
};
export const OPEN_CHAT_QUERY_PARAM_TRIGGER = 'openSupportChat';
export const UTM_SOURCE_QUERY_PARAM = 'utm_source';
export const OPEN_CHAT_BY_QUERY_PARAM_REASON = 'url_triggered_chat';
export const CACHE_KEY = 'SUPPORT.CHAT.STATE';
export const CACHE_LIFETIME = 8 * 60 * 1000; // 8 minutes

export const STATS_PREFIX = 'packages.support_chat_package';
export const STATUS_FETCH = {
    SUCCEEDED: 'succeeded',
    FAILED: 'failed',
};

export const FORETHOUGHT = {
    CHAT_SCRIPT_INITIATE: 'forethought.chat_script_initiate',
    CHAT_SCRIPT_INITIATED: 'forethought.chat_script_initiated',
    CHAT_SCRIPT_FAILED: 'forethought.chat_script_failed',
    CHAT_WIDGET_INITIATED: 'forethought.chat_widget_initiated',
    CHAT_WIDGET_FAILED: 'forethought.chat_widget_failed',
    CHAT_WIDGET_OPENED: 'forethought.chat_widget_opened',
    CHAT_WIDGET_CLOSED: 'forethought.chat_widget_closed',
    CHAT_WIDGET_TOGGLE_CLICKED: 'forethought.chat_widget_toggle_clicked',
    CHAT_WIDGET_CAMPAIGN_TRIGGERED: 'forethought.chat_widget_campaign_triggered',
    CHAT_WIDGET_CAMPAIGN_FAILED: 'forethought.chat_widget_campaign_failed',
};

export const USER_TYPES = {
    SELLER: 'seller',
    BUYER: 'buyer',
    SELLER_BUYER: 'seller_buyer',
    BUYER_SELLER: 'buyer_seller',
    RNC_SELLER: 'rnc_seller',
    PURE_BUYER: 'pure_buyer',
    PURE_MIX: 'pure_mix',
    MIX_SELLER_ORIENTATION: 'mix_seller_orientation',
    MIX_BUYER_ORIENTATION: 'mix_buyer_orientation',
};
